import { WORKFLOW_MODULE_ID } from './../../../../constants/workflow.constants';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StepService } from 'services/professional/step/step.service';
import { constants } from 'constants/constants';
import { MessageQueryService } from '@certemy/ui-components';
import { filesExistAndValid } from '@certemy/ui-components';
import { isStepSubmitted, isPendingVerificationStatus } from 'utils/step.helpers';
import { ComputedFrom } from '@certemy/common';
import { UploadConfirmInfo } from 'components/upload-confirm/confirm-info.interface';

export const PAGES = {
  MAIN_START: 'MAIN_START',
  UPLOAD_START: 'UPLOAD_START',
  UPLOAD_CONFIRM: 'UPLOAD_CONFIRM',
  RESET_CONFIRM: 'RESET_CONFIRM',
  BACK: 'BACK',
};

export interface ScreenChangePayload {
  page: string;
  toggleMode?: boolean;
}

@Component({
  selector: 'cm-evidence-file-details',
  styleUrls: ['./evidence-file-details.modal.component.scss'],
  templateUrl: './evidence-file-details.modal.component.html',
})
export class EvidenceFileDetailsComponent {
  @Input() step;
  @Input() workflowTypeId: number;
  @Output() updateStep = new EventEmitter();
  @Output() toggleMode: EventEmitter<string> = new EventEmitter();
  activePage: string;
  PAGES = PAGES;
  uploadInfo: UploadConfirmInfo;
  files: File[] = [];
  constants = constants;
  errorText: string;
  readonly fileUploadSettings = {
    maxSize: 30,
  };
  readonly WORKFLOW_MODULE_ID = WORKFLOW_MODULE_ID;

  @ComputedFrom('step')
  get isStepSubmitted() {
    return isStepSubmitted(this.step.status_id);
  }

  @ComputedFrom('step')
  get isPendingVerificationStatus() {
    return isPendingVerificationStatus(this.step.status_id);
  }

  constructor(
    public activeModal: NgbActiveModal,
    private stepService: StepService,
    private messageQueryService: MessageQueryService,
  ) {
    this.activePage = this.PAGES.MAIN_START;
  }

  goToPage(page: string): void {
    this.activePage = page;
  }

  closeModal() {
    this.activeModal.close();
  }

  dismissModal() {
    this.activeModal.dismiss();
  }

  backToPreviousPage(): void {
    this.onScreenChange({
      page: this.isStepSubmitted ? PAGES.MAIN_START : PAGES.UPLOAD_START,
      toggleMode: true,
    });
  }

  onFilesChange(files: File[]) {
    this.files = files;
  }

  onScreenChange({ page, toggleMode }: ScreenChangePayload) {
    if (toggleMode) {
      this.toggleMode.emit();
    }
    this.goToPage(page);
  }

  confirmUpload() {
    if (!filesExistAndValid(this.files, this.fileUploadSettings.maxSize)) {
      this.errorText = 'Please add file(s) with appropriate file size';
      return;
    }

    this.errorText = '';

    this.uploadInfo = {
      stepName: this.step.name,
      stepType: this.step.step_type_name,
      files: this.files,
      maxSize: this.fileUploadSettings.maxSize,
    };
    this.onScreenChange({
      page: PAGES.UPLOAD_CONFIRM,
      toggleMode: true,
    });
  }

  uploadFiles() {
    const formData: FormData = new FormData();

    for (const file of this.files) {
      formData.append('file[]', file, file.name);
    }

    this.stepService.uploadFeesStepEvidenceDocuments(this.step.step_instance_id, formData).subscribe(
      () => {
        this.closeModal();
        this.messageQueryService.addMessage('Document(s) are successfully uploaded');
      },
      (err) => {
        console.log(err);
        this.messageQueryService.addErrorMessage(
          'An error occurred while uploading the document(s). Please, try again',
        );
      },
    );
  }

  onResetConfirm() {
    this.stepService.resetStep(this.step.step_instance_id).subscribe(() => {
      this.messageQueryService.addMessage('Step has been successfully reset');
      this.updateStep.emit();
      this.onScreenChange({
        page: PAGES.MAIN_START,
        toggleMode: true,
      });
    });
  }
}
